import { gql } from '@apollo/client'

export const ALLOCATE_DRIVER_BIDS_MUTATION = gql`
  mutation AllocateDriverBids($ids: [Long!]!) {
    allocateDriverBids(bidIds: $ids) {
      id
      isAllocated
      isEnabled
      driver {
        id
        isActive
      }
    }
  }
`
export const DEALLOCATE_DRIVER_BIDS_MUTATION = gql`
  mutation DeallocateDriverBids($bookingId: Long!, $allocatedDriverIds: [Long!]!) {
    deallocateDriverBids(bookingId: $bookingId, allocatedDriverIds: $allocatedDriverIds) {
      id
      isAllocated
      isEnabled
      driver {
        id
        isActive
      }
    }
  }
`

export const CREATE_DRIVER_BID_MUTATION = gql`
  mutation CreateDriverBid($input: CreateAndUpdateDriverBidDtoInput!) {
    createDriverBid(input: $input) {
      id
      price
      eta
      notes
      bookingId
      vehicleId
      currencyId
      currency {
        id
        symbol
      }
      driverId
      isActive
    }
  }
`

export const Update_DRIVER_BID_MUTATION = gql`
  mutation UpdateDriverBid($input: CreateAndUpdateDriverBidDtoInput!) {
    updateDriverBid(input: $input) {
      id
      bookingId
    }
  }
`

export const DELETE_DRIVER_BID_MUTATION = gql`
  mutation DeleteDriverBid($id: Long!) {
    deleteDriverBid(driverId: $id)
  }
`

export const DISABLE_DRIVER_BID_MUTATION = gql`
  mutation DisableDriverBid($driverBidId: Long!) {
    disableDriverBid(driverBidId: $driverBidId)
  }
`
